const Settings = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M9.5 12a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.25 3.144a2.5 2.5 0 0 0-2.5 0L4.956 6.49a2.5 2.5 0 0 0-1.25 2.165v6.69a2.5 2.5 0 0 0 1.25 2.165l5.794 3.346a2.5 2.5 0 0 0 2.5 0l5.794-3.346a2.5 2.5 0 0 0 1.25-2.165v-6.69a2.5 2.5 0 0 0-1.25-2.165zm-2 .866a1.5 1.5 0 0 1 1.5 0l5.794 3.346a1.5 1.5 0 0 1 .75 1.299v6.69a1.5 1.5 0 0 1-.75 1.3L12.75 19.99a1.5 1.5 0 0 1-1.5 0l-5.794-3.346a1.5 1.5 0 0 1-.75-1.299v-6.69a1.5 1.5 0 0 1 .75-1.3z"
      clipRule="evenodd"
    />
  </>
)
export default Settings
